// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.primary-tooltip {
  background-color: #3F51B5;
}

.btn-submit {
  background-color: #0060d6;
  color: white;
  transition: background 0.3s ease-in-out;
}

.btn-submit:hover {
  background-color: #1a1a86;
}`, "",{"version":3,"sources":["webpack://./src/app/features/digital-identity/identity-provisioning/import-emp-info/import-emp-info.component.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;AACJ;;AAEA;EACE,yBAAA;EACA,YAAA;EACA,uCAAA;AACF;;AAEA;EACE,yBAAA;AACF","sourcesContent":[".primary-tooltip {\r\n    background-color: #3F51B5;\r\n}\r\n\r\n.btn-submit {\r\n  background-color: #0060d6;\r\n  color: #ffff;\r\n  transition: background 0.3s ease-in-out;\r\n}\r\n\r\n.btn-submit:hover {\r\n  background-color: #1a1a86;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
